/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessDto } from './UserAccessDto';
import {
    UserAccessDtoFromJSON,
    UserAccessDtoFromJSONTyped,
    UserAccessDtoToJSON,
    UserAccessDtoToJSONTyped,
} from './UserAccessDto';

/**
 * Response containing list of user access information
 * @export
 * @interface UserAccessListResponse
 */
export interface UserAccessListResponse {
    /**
     * List of user access information
     * @type {Array<UserAccessDto>}
     * @memberof UserAccessListResponse
     */
    data?: Array<UserAccessDto>;
    /**
     * Total number of users
     * @type {number}
     * @memberof UserAccessListResponse
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof UserAccessListResponse
     */
    page?: number;
    /**
     * Page size
     * @type {number}
     * @memberof UserAccessListResponse
     */
    pageSize?: number;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof UserAccessListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof UserAccessListResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the UserAccessListResponse interface.
 */
export function instanceOfUserAccessListResponse(value: object): value is UserAccessListResponse {
    return true;
}

export function UserAccessListResponseFromJSON(json: any): UserAccessListResponse {
    return UserAccessListResponseFromJSONTyped(json, false);
}

export function UserAccessListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserAccessDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function UserAccessListResponseToJSON(json: any): UserAccessListResponse {
    return UserAccessListResponseToJSONTyped(json, false);
}

export function UserAccessListResponseToJSONTyped(value?: UserAccessListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserAccessDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'success': value['success'],
        'error': value['error'],
    };
}

